import React, { createContext, useState } from "react";

// Context oluşturma
export const CashContext = createContext();

export const CashProvider = ({ children }) => {
  const [cashList, setCashList] = useState([
    {
      id: 1,
      date: "2025-09-01",
      paymentType: "Satış",
      paymentDirection: "Gelir",
      paymentMethod: "Nakit",
      status: "Tamamlandı",
      realizationDate: "2025-09-01",
      installment: "Tek Çekim",
      amount: 5000,
      description: "Ürün satışı",
    },
    {
      id: 2,
      date: "2025-09-03",
      paymentType: "Kira",
      paymentDirection: "Gider",
      paymentMethod: "Havale",
      status: "Beklemede",
      realizationDate: "2025-09-10",
      installment: "Aylık",
      amount: 2500,
      description: "Ofis kirası",
    },
  ]);

  // Ekleme
  const addCash = (cash) => {
    setCashList((prev) => [
      ...prev,
      { ...cash, id: prev.length > 0 ? prev[prev.length - 1].id + 1 : 1 },
    ]);
  };

  // Güncelleme
  const updateCash = (updatedCash) => {
    setCashList((prev) =>
      prev.map((c) => (c.id === updatedCash.id ? updatedCash : c))
    );
  };

  // Silme
  const deleteCash = (id) => {
    setCashList((prev) => prev.filter((c) => c.id !== id));
  };

  return (
    <CashContext.Provider value={{ cashList, addCash, updateCash, deleteCash }}>
      {children}
    </CashContext.Provider>
  );
};
